import React from "react";
import "./AppCardPersonaje.css";

export default function AppCardPersonaje({ img, nombre, bgColor, textColor, btnColor, onClick }) {
  return (
    <div className="home-personaje-card">
      <img src={img} alt={nombre || "Personaje"} className="home-personaje-img" />
      <div
        className="home-personaje-body"
        style={bgColor ? { backgroundColor: bgColor } : undefined}
      >
        {nombre && (
          <p
            className="home-personaje-desc"
            style={textColor ? { color: textColor } : undefined}
          >
            {nombre}
          </p>
        )}
        <button
          className="home-personaje-btn"
          style={btnColor ? { color: btnColor } : undefined}
          onClick={onClick}
        >
          Conócelo más
        </button>
      </div>
    </div>
  );
}
